import { Avatar, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { notificationBodyWrapSx } from './notificationTextClamp'

type Props = {
  title: string
  avatarSrc?: string
  fallbackIcon: React.ReactNode
  subtitle?: React.ReactNode
  time?: React.ReactNode
  avatarSize?: number
}

export function NotificationEntityHeader({
  title,
  avatarSrc,
  fallbackIcon,
  subtitle,
  time,
  avatarSize = 38,
}: Props) {
  const [imgFailed, setImgFailed] = useState(false)

  useEffect(() => {
    setImgFailed(false)
  }, [avatarSrc])

  const showImage = Boolean(avatarSrc) && !imgFailed

  return (
    <Stack direction="row" gap={1.5} alignItems="center" minWidth={0}>
      <Avatar
        src={showImage ? avatarSrc : undefined}
        alt={title}
        slotProps={{
          img: {
            onError: () => setImgFailed(true),
          },
        }}
        sx={{
          width: avatarSize,
          height: avatarSize,
          flex: '0 0 auto',
          bgcolor: showImage ? undefined : 'rgba(0,0,0,0.06)',
          color: 'rgba(0,0,0,0.54)',
          '& .MuiAvatar-img': {
            objectFit: 'cover',
          },
        }}
      >
        {!showImage ? fallbackIcon : null}
      </Avatar>

      <Stack minWidth={0} flex={1} gap={0.25}>
        <Typography variant="black-14-medium" sx={{ minWidth: 0, ...notificationBodyWrapSx }}>
          {title}
        </Typography>

        {(subtitle || time) && (
          <Stack direction="row" gap={1} alignItems="center" minWidth={0}>
            {subtitle != null && subtitle !== '' && (
              typeof subtitle === 'string' ? (
                <Typography variant="black-12-light" sx={{ minWidth: 0, ...notificationBodyWrapSx }}>
                  {subtitle}
                </Typography>
              ) : (
                <Stack direction="row" gap={0.75} alignItems="center" minWidth={0} flexWrap="wrap">
                  {subtitle}
                </Stack>
              )
            )}
            {time && (
              <Typography variant="black-12-light" sx={{ flex: '0 0 auto' }}>
                {time}
              </Typography>
            )}
          </Stack>
        )}
      </Stack>
    </Stack>
  )
}
